import React from 'react';
import { useSelector } from 'react-redux';
import { ReactComponent as FileIcon } from '../../assets/file-with-text-icon.svg';
import { ReactComponent as ReportIcon } from '../../assets/report-icon.svg';
import { instance  } from '../../store/utils';
import './PlatformSwitcher.css';

export default function PlatformSwitcher() {
  const user = useSelector((state) => state.user);

  const handleInternalAuditClick = async () => {
    try {
      const { roleAudit, email, firstName, lastName, username, token } = user;
      const response = await instance.post(
        '/api/user/request-ram-token',
        {
          roles: [roleAudit],
          email,
          firstName,
          lastName,
          username,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.status === 200 && response.data?.success) {
        const { access_token, refresh_token } = response.data.data;
        localStorage.setItem('ramToken', access_token);
        localStorage.setItem('ramRefreshToken', refresh_token);
        window.location.href = '/internal-audit/';
      }
    } catch (error) {
      console.error('Failed to request RAM token', error);
    }
  };

  return (
    <div className="dropdown">
      <div className="body">
        <button
          type="button"
          className="item"
          onClick={handleInternalAuditClick}
        >
          <ReportIcon className="icon" />
          <span className="gradientText">Internal Audit Module</span>
        </button>

        <button type="button" className="item">
          <FileIcon className="icon" />
          <span className="gradientText">Regulatory Compliance Module</span>
        </button>
      </div>
    </div>
  );
}
